import { render, staticRenderFns } from "./AuthBrandPanel.vue?vue&type=template&id=29f1b10a&scoped=true"
import script from "./AuthBrandPanel.vue?vue&type=script&lang=js"
export * from "./AuthBrandPanel.vue?vue&type=script&lang=js"
import style0 from "./AuthBrandPanel.vue?vue&type=style&index=0&id=29f1b10a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f1b10a",
  null
  
)

export default component.exports